import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Box, setRef, Stack, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import Task from "@mui/icons-material/Task";
import ReportNavigation from "../../Components/ReportNavigation/ReportNavigation";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import ReportLoadingDialog from "../../Components/ReportLoadingDialog";
toast.configure();
const InvoiveWiseCase = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  //TIMEOUT WHEN JWT EXPIRES
  // setTimeout(() => {
  //   window.location.reload(false);
  // }, 1800000);

  // TEXT FIELD VALUE STATES
  const date = new Date();
  const [fromdate, setfromdate] = useState(null);
  const [todate, settodate] = useState(date);
  const [pdfStream, setPdfStream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reporttype, setreporttype] = useState("A");
  const [genrating, setgenrating] = useState(false);
  const [reportText, setReportText] = useState({
    title: "",
    subtitle: "",
  });
  const Flags = [
    {
      value: "A",
      label: "All",
    },
    {
      value: "T",
      label: "Transit",
    },
    {
      value: "G",
      label: "Grn Created",
    },
  ];
  const [rows, setrows] = useState([]);
  const columns = [
    {
      field: "srl",
      headerClassName: "super-app-theme--header",
      headerName: "Srl",
      width: 80,
    },
    {
      field: "invno",
      headerClassName: "super-app-theme--header",
      headerName: "Invno",
      width: 250,
    },
    {
      field: "invdate",
      headerClassName: "super-app-theme--header",
      headerName: "InvDate",
      width: 150,
    },
    {
      field: "casenumber",
      headerClassName: "super-app-theme--header",
      headerName: "CaseNumber",
      width: 250,
    },
    {
      field: "casedate",
      headerClassName: "super-app-theme--header",
      headerName: "CaseDate",
      width: 250,
    },
    {
      field: "inwardno",
      headerClassName: "super-app-theme--header",
      headerName: "Inwardno",
      width: 250,
    },
    {
      field: "inwarddate",
      headerClassName: "super-app-theme--header",
      headerName: "InwardDate",
      width: 250,
    },
  ];
  //fetch state data
  async function getfromdatedata() {
    try {
      const response = await fetch("/reports/fromdate", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const jsonData = await response.json();
      setfromdate(jsonData.fromdate);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getfromdatedata();
  }, []);

  //fetch data
  const handleReport = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating Invoice Wise Case File Report",
      subtitle: "Preparing PDF report. Please wait…",
    });

    setgenrating(true);
    try {
      const body = { fromdate, todate, reporttype };
      const response = await fetch("/invoicewisecasefile/view", {
        method: "POST",
        headers: { "Content-Type": "application/json", sptoken: userToken },
        body: JSON.stringify(body),
      });
      const jsonData = await response.json();
      setrows(jsonData);
      setgenrating(false);
    } catch (err) {
      setgenrating(false);
      console.log(err.message);
    }
  };
  //data only excel
  const printexcel = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating Invoice Wise Case File Report",
      subtitle: "Preparing Excel report. Please wait…",
    });

    setgenrating(true);
    if (fromdate === null) {
      return toast.error("Please Select The From Date!!");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      //partyarray = parray.map((opt) => opt.subledgerid);
      const body = { fromdate: fromDateStr, todate: toDateStr, reporttype };
      const data = await fetch("/invoicewisecasefile/excel", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "InvoiceWiseCaseFile.xlsx";

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };
  return (
    <>
          <ReportLoadingDialog
        open={genrating}
        title={reportText.title}
        subtitle={reportText.subtitle}
      />
      <Sidebar
        Title={"Invocie Wise Casefile Report"}
        expandedPanel={"panel3"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            //onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Box
              sx={{
                marginTop: "4rem",
                display: "flex",
                flexWrap: "wrap",
                columnGap: "20px",
                justifyContent: "center",
              }}
            >
              {" "}
              <TextField
                id="category"
                required
                select
                label="Category"
                value={reporttype}
                onChange={(e) => {
                  setreporttype(e.target.value);
                }}
                // helperText="Please select 'Direct' or 'Transit'."
                variant="outlined"
                sx={{
                  width: "20%",
                }}
                size="small"
              >
                {Flags.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  inputFormat="DD/MM/YYYY"
                  value={fromdate}
                  onChange={(newValue) => {
                    setfromdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  inputFormat="DD/MM/YYYY"
                  value={todate}
                  onChange={(newValue) => {
                    settodate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <Button
                type="submit"
                onClick={handleReport}
                disabled={loading === true}
                variant="contained"
                component="label"
                size="large"
                sx={{ boxShadow: "2px 2px 6px  #404142" }}
                endIcon={<Task />}
              >
                {loading ? "Fetching Data..." : " Show Report"}
              </Button>
              <Button
                onClick={printexcel}
                size="small"
                variant="contained"
                color="success"
                //endIcon={<PrintIcon />}
              >
                Excel
              </Button>
            </Box>
            <Box
              sx={{
                height: 550,
                width: "100%",
                position: "relative",
                mt: "15px",
                boxShadow: "2px 6px 15px #5a5a5a",
                // border: "0.5px solid black",
                // borderRadius: "5px",
                "& .super-app-theme--header": {
                  backgroundColor: "#3bb9ff",
                  color: "#000",
                },
                "& .custom-font-size": {
                  fontSize: 13, // Adjust the font size as needed
                },
              }}
            >
              <DataGrid
                sx={{
                  border: "1px solid #000",
                  "& .MuiDataGrid-cell:focus": {
                    outline: "2px solid red", // Change this to the desired color
                    backgroundColor: "gray",
                    color: "white",
                  },
                }}
                rowHeight={35}
                headerHeight={30}
                showColumnRightBorder={true}
                rows={rows}
                columns={columns}
                pageSize={100}
                getRowId={(row) => row.srl}
              />
            </Box>
            {pdfStream && (
              <ReportNavigation
                //onDownload={handleDownload}
                reportName={"GOVT GST"}
              />
            )}
            <Box sx={{ backgroundColor: "white" }}>
              {pdfStream && (
                <iframe
                  src={pdfStream}
                  width="100%"
                  height="680px"
                  title="report"
                ></iframe>
              )}
            </Box>
          </Box>
        }
      />
      {/* <FooterElement /> */}
      {redirectToLoginPage()}
    </>
  );
};

export default InvoiveWiseCase;
